import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";

export default function SignificantOtherInviteDialog(props) {

	const [state, setState] = useState({});
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setState({
			...state,
			updated: true,
			[event.target.name]: event.target.value,
		});
	};
	const handleSendMessage = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(state),
		};
		fetch("/api/db453fe4d711490d8e935081e4f783bd/" + props.state.params.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Inviter mon/ma conjoint(e)
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Fragment>
					<Stack justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
						<FormControl component="fieldset">
							<RadioGroup
								row
								aria-label="gender"
								name="gender"
								defaultValue={state.gender}
								onChange={handleChange}
								value={state.gender}
								dense
							>
								<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
								<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
							</RadioGroup>
						</FormControl>
						<TextField
							id="firstname"
							name="firstname"
							variant="outlined"
							style={{
								marginLeft: 0,
								marginRight: 0,
							}}
							placeholder="Prénom"
							fullWidth
							margin="dense"
							size="small"
							value={state.firstname}
							onChange={handleChange}
						/>
					</Stack>
					<TextField
						id="lastname"
						name="lastname"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
						}}
						placeholder="Nom"
						fullWidth
						margin="dense"
						size="small"
						value={state.lastname}
						onChange={handleChange}
					/>
					<TextField
						id="email"
						name="email"
						variant="outlined"
						style={{
							marginLeft: 0,
							marginRight: 10,
						}}
						placeholder="Email"
						fullWidth
						margin="dense"
						size="small"
						value={state.email}
						onChange={handleChange}
					/>
				</Fragment>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="space-between" style="width: 100%">
					<Box>
						<Button onClick={handleClose}>Annuler</Button>
					</Box>
					<Box>
						<Button
							variant="contained"
							onClick={handleSendMessage}
							disabled={!state.email || !state.firstname
								|| !state.lastname || !state.gender}
						>
							Inviter
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
